import { BannerImageInt, DestinationsInt } from "@interfaces/";

export class Destinations {
    static destinations: DestinationModel[] = [];
    static findDestination(d: string): DestinationModel {
        if(this.getDestinations().length === 0){
            return new DestinationModel();
        }
        return  this.getDestinations().find(
            (res: DestinationModel) =>  {
                return res.code === d
            })!;


    }

    static setDestinations(destinations: DestinationModel[]) {
        this.destinations = destinations;
    }

    static getDestinations(): DestinationModel[]{
        return this.destinations;
    }
}

export class DestinationModel implements DestinationsInt {
    airportName: string = "";
    country: string = "";
    city: string = "";
    nearbyAirports: string = "";
    code: string = "";
    imgUrl: string = "";
    isOperatingByAm: string = "";
    location: BannerImageInt;
    constructor (
        destination?: DestinationsInt
    ) {
        if ( destination ) {
            this.airportName = destination.airportName;
            this.country = destination.country;
            this.city = destination.city;
            this.nearbyAirports = destination.nearbyAirports;
            this.code = destination.code;
            this.imgUrl = destination.imgUrl;
            this.isOperatingByAm = destination.isOperatingByAm;
            this.location = destination.location;
        }
    }

}
